import React from "react";
import {SelectOption} from "@/types";

type Props = {
    options: SelectOption[];
    selected: string;
    shinsakikan_sinseitaio_error?: string;
    setValue: (name: string, value: string | boolean) => void;
};

const descriptions: Record<string, string> = {
    '不要': 'データ納品で完了',
    '必要': '審査機関への申請・質疑も対応',
};

export const ShinsakikanTaionoUmu = ({options, selected, shinsakikan_sinseitaio_error, setValue}: Props) => {
    return (
        <div className="form-flex">
            <div className="form-flex-txt">審査機関対応の有無</div>
            <div className="form-flex-input">
                <div className={`form_shinsakikan_taiono_umu form-flex-input-radio01${shinsakikan_sinseitaio_error ? ' form-input-error' : ''}`}>
                    {options.map((option) => (
                        <label key={option.id}>
                            <input
                                type="radio"
                                name="shinsakikan_sinseitaio"
                                value={option.id}
                                required
                                checked={selected === option.id}
                                onChange={() => setValue('shinsakikan_sinseitaio', option.id)}
                            /> <span className="name">{option.name}</span>
                            {descriptions[option.name] && (
                                <><br/><span className="desc">{descriptions[option.name]}</span></>
                            )}
                        </label>
                    ))}
                </div>

                {shinsakikan_sinseitaio_error &&
                    <div className="form-error-message">{shinsakikan_sinseitaio_error}</div>}
            </div>
        </div>
    );
};
